"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = Tooltip;
var _react = _interopRequireDefault(require("react"));
var _BaseTooltip = require("../../baseComponents/BaseTooltip/__BaseTooltip");
var _TooltipBody = require("./TooltipBody");
var _Tooltip = _interopRequireDefault(require("./Tooltip.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function Tooltip(_ref) {
  var children = _ref.children,
    content = _ref.content,
    header = _ref.header,
    href = _ref.href,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'top' : _ref$position;
  var classes = (0, _Tooltip.default)({
    position: position
  });
  var tooltipClasses = {
    tooltip: classes.tooltip,
    arrow: classes.arrow
  };
  var tooltipBodyClassses = {
    header: classes.header,
    content: classes.content,
    footer: classes.footer
  };
  return /*#__PURE__*/_react.default.createElement(_BaseTooltip.__BaseTooltip, {
    title: /*#__PURE__*/_react.default.createElement(_TooltipBody.TooltipBody, {
      classes: tooltipBodyClassses,
      header: header,
      content: content,
      href: href
    }),
    arrow: true,
    interactive: true,
    classes: tooltipClasses,
    placement: position
  }, children);
}